import Cookies from 'js-cookie';
import { isProduction } from 'src/libs/wa/utils/env';
import type { CartItem } from 'src/models/orderLimits/schema';
import { getDomainForCookie } from 'src/utils/url';

// authに関するcookie関連
const ACCESS_TOKEN_KEY = 'accessToken';
const REFRESH_TOKEN_KEY = 'token';

export const deleteAuthCookies = () => {
  Cookies.remove(ACCESS_TOKEN_KEY, {
    path: '/',
    domain: getDomainForCookie()
  });
  Cookies.remove(REFRESH_TOKEN_KEY, {
    path: '/',
    domain: getDomainForCookie()
  });
};

export const setAuthCookies = (accessToken: string, refreshToken: string) => {
  Cookies.set(ACCESS_TOKEN_KEY, accessToken, {
    domain: getDomainForCookie(),
    expires: process.env.NEXT_PUBLIC_ACCESS_TOKEN_EXPIRES,
    secure: isProduction()
  });

  Cookies.set(REFRESH_TOKEN_KEY, refreshToken, {
    domain: getDomainForCookie(),
    expires: process.env.NEXT_PUBLIC_ACCESS_TOKEN_EXPIRES,
    secure: isProduction()
  });
};

export const getCookieNames = () => document.cookie.split('; ').map((cookie) => cookie.split('=')[0]);

export const getAccessToken = () => {
  return Cookies.get(ACCESS_TOKEN_KEY) || process.env.NEXT_PUBLIC_ACCESS_TOKEN;
};

export const getRefreshToken = () => {
  return Cookies.get(REFRESH_TOKEN_KEY);
};

// couponに関するcookie関連
const ISSUED_COUPON = 'issuedCoupon';
export const getIssuedCouponStatus = () => {
  return Cookies.get(ISSUED_COUPON);
};
export const setIssuedCouponStatus = (status: 'true' | 'false') => {
  Cookies.set(ISSUED_COUPON, status);
};

// shopに関するcookie関連
const SHOP_ID = 'shopId';
// getServerSidePropsで使うだけなのでsetするだけで良い
export const setShopId = (shopId: string) => {
  Cookies.set(SHOP_ID, shopId);
};

// cart に関する
const CART_ID = 'cartID';
// CartItem
export const getCartFromCookie = () => {
  const content = Cookies.get(CART_ID);
  if (content) {
    const value = JSON.parse(content);
    if (Array.isArray(value)) {
      return value.filter((item): item is CartItem => item.productId && item.quantity);
    }
  }
  return [];
};

export const saveCartToCookie = (cart: CartItem[]) => {
  return Cookies.set(CART_ID, JSON.stringify(cart), { expires: 30, domain: getDomainForCookie() });
};

export const clearCartInCookie = () => {
  return saveCartToCookie([]);
};
